var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"convey-required-statement"},[_c('b-icon',{attrs:{"icon":"info-circle"}}),_vm._v("  All fields marked with an asterisk ("),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(") are required. ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }